import { Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'
import { Email, Image03, Images } from 'blaze-ui/icons/24'
import { File02, VideoOn } from 'blaze-ui/icons'
import { Iphone02 } from 'blaze-ui/icons/16'

export interface StrategyValuesV2Props {
  strategy: StrategyType
}

export const StrategyValuesV2 = ({ strategy }: StrategyValuesV2Props) => {
  const seoContentsCount = strategy.seo_contents.find((content) => content.type === 'blog_post')?.count || 0
  const newsletterContentsCount = strategy.email_contents.find((content) => content.type === 'newsletter')?.count || 0
  const stillImageSocialCrosspostContentsCount =
    strategy.crosspost_contents.find((content) => content.content_type === 'still_image')?.count || 0
  const carouselSocialCrosspostContentsCount =
    strategy.crosspost_contents.find((content) => content.content_type === 'carousel')?.count || 0
  const videoSocialCrosspostContentsCount =
    strategy.crosspost_contents.find((content) => content.content_type === 'video')?.count || 0
  const videoCrosspostContentsCount =
    strategy.video_crosspost_contents.find((content) => content.type === 'post')?.count || 0

  return (
    <div className={Styles.strategyValues}>
      {stillImageSocialCrosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              <Image03 size={15} color="#FD4242" />
            </div>
            <Text variant="secondary">
              {stillImageSocialCrosspostContentsCount} Still{' '}
              {pluralize('image', stillImageSocialCrosspostContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {carouselSocialCrosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              <Images size={15} color="var(--starter)" />
            </div>
            <Text variant="secondary">
              {carouselSocialCrosspostContentsCount} {pluralize('Carousel', carouselSocialCrosspostContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {videoSocialCrosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              <VideoOn size={15} color="var(--upgrade)" />
            </div>
            <Text variant="secondary">
              {videoSocialCrosspostContentsCount} Video Feed {pluralize('Post', videoSocialCrosspostContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {videoCrosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              <Iphone02 size={15} color="#0AF" />
            </div>
            <Text variant="secondary">
              {videoCrosspostContentsCount} Short Form {pluralize('Video', videoCrosspostContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {newsletterContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              <File02 size={15} color="#20A14F" />
            </div>
            <Text variant="secondary">
              {newsletterContentsCount} {pluralize('Email', newsletterContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {seoContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              <Email size={15} color="#FFAE00" />
            </div>
            <Text variant="secondary">
              {seoContentsCount} {pluralize('Blog', seoContentsCount)}
            </Text>
          </div>
        </>
      )}
    </div>
  )
}
